/* -------------------------------------------------------------------
   KV: keep the product notices and the two hidden order properties in
   step with the SELECTED size.

   Edge does not re-render the product form on a variant change — it
   swaps only the submit button, variant id, price and stock line. So the
   Liquid in kv-product-flags.liquid writes every variant's state out as
   JSON once, and this decides which notice and which hidden input is
   live each time the selection changes.

   A disabled input is not submitted, which is how a property is turned
   off without removing it from the DOM.

   Writes are idempotent — setting hidden/disabled to the value they
   already hold produces no mutation — so the observer below cannot
   feed itself.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__kvProductFlags) return;
  window.__kvProductFlags = true;

  function setRole(host, role, on) {
    var note = host.querySelector('[data-kv-role="' + role + '"]');
    var input = host.querySelector('[data-kv-role="' + role + '-input"]');
    if (note && note.hidden === on) note.hidden = !on;
    if (input && input.disabled === on) input.disabled = !on;
  }

  function apply() {
    var hosts = document.querySelectorAll("kv-product-flags");
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var map;
      try {
        map = JSON.parse(host.getAttribute("data-kv-variants") || "{}");
      } catch (e) {
        continue; // malformed data: leave both properties off rather than guess
      }
      var form = host.closest("form");
      var idField = (form || document).querySelector(".product-variant-id");
      var id = idField ? String(idField.value || "") : "";
      var state = map[id] || { p: 0, f: 0 };
      setRole(host, "preorder", !!state.p);
      setRole(host, "final", !!state.f);
    }
  }

  /* Edge updates the variant id asynchronously and by more than one
     route, so watch for the DOM settling rather than any single event. */
  function nudge() {
    apply();
    setTimeout(apply, 120);
    setTimeout(apply, 450);
    setTimeout(apply, 1000);
  }

  function boot() {
    apply();

    var scope = document.querySelector("product-info") || document.body;
    var timer;
    try {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(apply, 60);
      }).observe(scope, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["value", "checked", "disabled", "class"]
      });
    } catch (e) {
      /* no observer: the listeners below still cover the common path */
    }

    document.addEventListener("change", nudge, true);
    document.addEventListener("click", function (event) {
      if (event.target.closest(".swatch-block, .product-form__input, label")) nudge();
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
